// Feature 159: larghezza del pannello (US2). Tra 340 px e il 75% della finestra, ricordata nel browser.

export const LARGHEZZA_MINIMA = 340;
export const LARGHEZZA_PREDEFINITA = 440;
export const SOGLIA_MOBILE = 768;
const CHIAVE = 'archiconnect-v2-ai-chat-larghezza';

export class AiChatLarghezza {
  valore = LARGHEZZA_PREDEFINITA;
  espanso = false;
  private precedente = LARGHEZZA_PREDEFINITA;

  constructor(private readonly finestra: () => number = () => window.innerWidth) {
    this.valore = this.limita(leggi() ?? LARGHEZZA_PREDEFINITA);
  }

  get massima(): number {
    return Math.max(LARGHEZZA_MINIMA, Math.floor(this.finestra() * 0.75));
  }

  /** Sotto i 768 px il pannello occupa tutto lo schermo. */
  get mobile(): boolean {
    return this.finestra() < SOGLIA_MOBILE;
  }

  limita(larghezza: number): number {
    return Math.min(this.massima, Math.max(LARGHEZZA_MINIMA, Math.round(larghezza)));
  }

  /** Trascinamento: la maniglia è sul bordo sinistro, il pannello è ancorato a destra. */
  trascina(clientX: number) {
    this.valore = this.limita(this.finestra() - clientX);
    this.espanso = false;
  }

  predefinita() {
    this.valore = this.limita(LARGHEZZA_PREDEFINITA);
    this.espanso = false;
    this.salva();
  }

  alternaEspansione() {
    if (this.espanso) {
      this.valore = this.limita(this.precedente);
    } else {
      this.precedente = this.valore;
      this.valore = this.massima;
    }
    this.espanso = !this.espanso;
  }

  /** La finestra si è ristretta: la larghezza rientra nei limiti senza essere salvata. */
  adatta() {
    this.valore = this.limita(this.valore);
  }

  salva() {
    try {
      localStorage.setItem(CHIAVE, `${this.valore}`);
    } catch {
      // Storage non disponibile (navigazione privata, dati bloccati): la larghezza vale per la sessione.
    }
  }
}

function leggi(): number | null {
  try {
    const valore = Number(localStorage.getItem(CHIAVE));
    return Number.isFinite(valore) && valore > 0 ? valore : null;
  } catch {
    return null;
  }
}
